import { AIChatWidget } from '@/components/ai/ai-chat-widget';
import TopNav from '@/components/navigation/top-nav';
import UserSidebar from '@/components/navigation/user-sidebar';
import { VerificationBanner } from '@/components/ui/verification-banner';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/(user-dashboard)/dashboard/_dashboard')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className={`flex h-screen `}>
      <UserSidebar />
      <div className="w-full flex flex-1 flex-col">
        <VerificationBanner />
        <header className="h-16 border-b ">
          <TopNav />
        </header>
        <main className="flex-1 overflow-auto p-6 ">
          <AIChatWidget />
          <Outlet />
        </main>
      </div>
    </div>
  );
}
